
    import I18n from 'i18nObj';
    
      import 'translations/file_rename_form';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('file_rename_form');
  